import { Checkbox } from "app/components/Checkbox/Checkbox";
import NumberInput from "app/components/NumberInput/NumberInput";
import { useEffect, useRef, useState } from "react";

type Props = {
  lossLimit: number | undefined;
  newLimit: number | undefined | null;
  label: string;
  updateLossLimit: (id: string, newLimitValue: null | number | string) => void;
  id: string;
  isCheckBoxDisabled: boolean;
  isCheckBoxSelected: boolean;
  handleCheckboxChange: (checked: boolean) => {};
};

const UpdateLossLimitsRow: React.FC<Props> = ({
  lossLimit,
  newLimit,
  label,
  updateLossLimit,
  id,
  isCheckBoxDisabled,
  isCheckBoxSelected,
  handleCheckboxChange,
}) => {
  const [isInputDisabled, setIsInputDisabled] = useState(true);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // Set focus on the input box after the checkbox is selected
    if (isCheckBoxSelected && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isCheckBoxSelected]);

  const handleInputChange = (newLimitValue: number | string | null) => {
    updateLossLimit(id, newLimitValue);
  };

  return (
    <div className="Loss-limits-row">
      <div className="loss-limit__input">
        <label
          className="text-input-container__input-label"
          htmlFor="limit-input"
        >
          {label}
        </label>
        <NumberInput
          onUpdate={newLimitValue => {
            handleInputChange(newLimitValue);
          }}
          value={isCheckBoxSelected ? newLimit : lossLimit}
          disabled={isInputDisabled}
          inputRef={inputRef}
        />
      </div>
      <Checkbox
        disabled={isCheckBoxDisabled}
        checked={isCheckBoxSelected}
        onChange={e => {
          handleCheckboxChange(e.currentTarget.checked);
          setIsInputDisabled(!e.currentTarget.checked);
        }}
        id={label}
      />
    </div>
  );
};

export default UpdateLossLimitsRow;
